const returnEnvironment = (environmentHost) => {
  let environment = '';
  if (environmentHost.includes('localhost')) {
    environment = 'local';
  } else if (environmentHost.includes('dev')) {
    environment = 'dev';
  } else if (environmentHost.includes('staging')) {
    environment = 'staging';
  } else {
    environment = 'production';
  }
  return environment;
};

export default returnEnvironment;
